module.exports = __webpack_public_path__ + "img/i11.bd119a3f.svg";